import { UnsupportedWalletAccountSource } from './errors.js';
import assert from 'minimalistic-assert';
const MODULE_ID = 'messageSigner';
class MessageSigner {
    #seedBasedMessageSigner;
    #hardwareMessageSigner;
    #walletAccountsAtom;
    constructor({ hardwareMessageSigner, seedBasedMessageSigner, walletAccountsAtom }) {
        this.#seedBasedMessageSigner = seedBasedMessageSigner;
        this.#hardwareMessageSigner = hardwareMessageSigner;
        this.#walletAccountsAtom = walletAccountsAtom;
    }
    #getMessageSigner = async (walletAccount) => {
        if (walletAccount.isSoftware) {
            return this.#seedBasedMessageSigner;
        }
        if (walletAccount.isHardware && this.#hardwareMessageSigner) {
            return this.#hardwareMessageSigner;
        }
        throw new UnsupportedWalletAccountSource(walletAccount.source);
    };
    #normalizeWalletAccount = async (walletAccount) => {
        if (typeof walletAccount === 'string') {
            const walletAccounts = await this.#walletAccountsAtom.get();
            const instance = walletAccounts[walletAccount];
            assert(instance, `wallet account ${walletAccount} not found`);
            return instance;
        }
        return walletAccount;
    };
    signMessage = async (opts) => {
        const { baseAssetName, message, purpose } = opts;
        const walletAccount = await this.#normalizeWalletAccount(opts.walletAccount);
        const signer = await this.#getMessageSigner(walletAccount);
        return signer.signMessage({
            baseAssetName,
            walletAccount,
            purpose,
            message,
        });
    };
}
const createMessageSigner = (opts) => new MessageSigner(opts);
const messageSignerDefinition = {
    id: MODULE_ID,
    type: 'module',
    factory: createMessageSigner,
    dependencies: ['seedBasedMessageSigner', 'hardwareMessageSigner?', 'walletAccountsAtom'],
    public: true,
};
export default messageSignerDefinition;
